type PrintMode = 'tcvs-print-single-label' | 'tcvs-print-label-sheet';

const SINGLE_PRINT_TARGET_CLASS = 'tcvs-print-single-target';

function clearSinglePrintTarget(): void {
  document.querySelectorAll(`.${SINGLE_PRINT_TARGET_CLASS}`).forEach((node) => node.remove());
}

function activeLabelFromEvent(
  event: { currentTarget: EventTarget | null } | undefined,
): Element | null {
  const target = event?.currentTarget;
  if (target instanceof Element) return target.closest('.tcvs-print-label');
  return document.querySelector('.tcvs-print-label');
}

function mountSinglePrintTarget(label: Element | null | undefined): void {
  clearSinglePrintTarget();
  if (label === null || label === undefined) return;
  const target = document.createElement('div');
  target.className = SINGLE_PRINT_TARGET_CLASS;
  target.appendChild(label.cloneNode(true));
  document.body.appendChild(target);
}

function printWithMode(mode: PrintMode, activeLabel?: Element | null): void {
  const { body } = document;
  if (mode === 'tcvs-print-single-label') {
    mountSinglePrintTarget(activeLabel);
  } else {
    clearSinglePrintTarget();
  }
  body.classList.remove('tcvs-print-single-label', 'tcvs-print-label-sheet');
  body.classList.add(mode);

  const cleanup = (): void => {
    body.classList.remove(mode);
    clearSinglePrintTarget();
    window.removeEventListener('afterprint', cleanup);
    window.removeEventListener('focus', cleanup);
  };

  window.addEventListener('afterprint', cleanup);
  window.setTimeout(() => {
    window.print();
    window.setTimeout(() => {
      window.addEventListener('focus', cleanup, { once: true });
    }, 0);
  }, 0);
}

export function printSingleLabel(event?: { currentTarget: EventTarget | null }): void {
  printWithMode('tcvs-print-single-label', activeLabelFromEvent(event));
}

export function printLabelSheet(): void {
  printWithMode('tcvs-print-label-sheet');
}
